module.exports = __webpack_public_path__ + "static/img/ico_bottom_qrcode.01f27b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/ico_bottom_qrcode.png
// module id = 5/RI
// module chunks = 0